module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_10X_Section2.ed9ea0a2.png";